import * as Types from '../Constants/AllConstants';

export const GetAllPaymentMethodsReducer = (state = { paymentMethods: [] }, action) => {
  switch (action.type) {
    case Types.PAYMENT_METHOD_LIST_REQUEST:
      return { loading: true };
    case Types.PAYMENT_METHOD_LIST_SUCCESS:
      return { loading: false, paymentMethods: action.payload };
    case Types.PAYMENT_METHOD_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const GetPaymentMethodCodesReducer = (state = { codes: [] }, action) => {
  switch (action.type) {
    case Types.PAYMENT_METHOD_CODES_REQUEST:
      return { loading: true };
    case Types.PAYMENT_METHOD_CODES_SUCCESS:
      return { loading: false, codes: action.payload };
    case Types.PAYMENT_METHOD_CODES_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const GetPagedPaymentMethodsReducer = (state = { paymentMethods: [], page: 0, pages: 0 }, action) => {
  switch (action.type) {
    case Types.PAYMENT_METHOD_PAGED_REQUEST:
      return { loading: true };
    case Types.PAYMENT_METHOD_PAGED_SUCCESS:
      return {
        loading: false,
        paymentMethods: action.payload.content,
        page: action.payload.number,
        pages: action.payload.totalPages,
      };
    case Types.PAYMENT_METHOD_PAGED_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const PaymentMethodDetailsReducer = (state = { paymentMethod: {} }, action) => {
  switch (action.type) {
    case Types.PAYMENT_METHOD_DETAILS_REQUEST:
      return { loading: true };
    case Types.PAYMENT_METHOD_DETAILS_SUCCESS:
      return { loading: false, paymentMethod: action.payload };
    case Types.PAYMENT_METHOD_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const CreatePaymentMethodReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.PAYMENT_METHOD_CREATE_REQUEST:
      return { loading: true };
    case Types.PAYMENT_METHOD_CREATE_SUCCESS:
      return { loading: false, success: true, paymentMethod: action.payload };
    case Types.PAYMENT_METHOD_CREATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.PAYMENT_METHOD_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

export const UpdatePaymentMethodReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.PAYMENT_METHOD_UPDATE_REQUEST:
      return { loading: true };
    case Types.PAYMENT_METHOD_UPDATE_SUCCESS:
      return { loading: false, success: true, paymentMethod: action.payload };
    case Types.PAYMENT_METHOD_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case Types.PAYMENT_METHOD_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

export const DeletePaymentMethodReducer = (state = {}, action) => {
  switch (action.type) {
    case Types.PAYMENT_METHOD_DELETE_REQUEST:
      return { loading: true };
    case Types.PAYMENT_METHOD_DELETE_SUCCESS:
      return { loading: false, success: true };
    case Types.PAYMENT_METHOD_DELETE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
